// extracted by mini-css-extract-plugin
module.exports = {"profileImage":"profile-image_profileImage__1QCCh","picturePlaceholder":"profile-image_picturePlaceholder__2_HuY"};